"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/no-children-prop */
const React = tslib_1.__importStar(require("react"));
const Tooltip_1 = tslib_1.__importDefault(require("@mui/material/Tooltip"));
const Tooltip = (_a) => {
    var { placement = 'top', children, disabled = false, className } = _a, rest = tslib_1.__rest(_a, ["placement", "children", "disabled", "className"]);
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({}, rest, { disableTouchListener: disabled, disableHoverListener: disabled, disableFocusListener: disabled, placement: placement, arrow: true }, { children: (0, jsx_runtime_1.jsx)(Content, { children: children, className: className }) })));
};
const Content = React.forwardRef((_a, ref) => {
    var { children, className } = _a, rest = tslib_1.__rest(_a, ["children", "className"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: className }, rest, { ref: ref, style: { display: 'inline-flex' } }, { children: children })));
});
exports.default = React.memo(Tooltip);
